import React from "react";

// Decorative SVG icons matching the business card line style.
export function CombIcon({ className = "h-10 w-10", stroke = "currentColor" }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <rect x="8" y="10" width="48" height="14" rx="2" />
      <line x1="14" y1="24" x2="14" y2="54" />
      <line x1="20" y1="24" x2="20" y2="50" />
      <line x1="26" y1="24" x2="26" y2="52" />
      <line x1="32" y1="24" x2="32" y2="48" />
      <line x1="38" y1="24" x2="38" y2="52" />
      <line x1="44" y1="24" x2="44" y2="50" />
      <line x1="50" y1="24" x2="50" y2="54" />
    </svg>
  );
}

export function LipstickIcon({ className = "h-10 w-10", stroke = "currentColor" }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M22 14 L36 6 L40 26 L22 26 Z" />
      <rect x="18" y="26" width="26" height="10" />
      <rect x="20" y="36" width="22" height="22" />
    </svg>
  );
}

export function SparkleIcon({ className = "h-6 w-6", stroke = "currentColor" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M12 2 L13.8 9.2 L21 11 L13.8 12.8 L12 20 L10.2 12.8 L3 11 L10.2 9.2 Z" />
    </svg>
  );
}

export function LogoWordmark({ size = "text-7xl md:text-9xl" }) {
  return (
    <span className={`logo-word ${size} text-ink leading-[0.85]`}>
      R<span className="text-coral">M</span>orrison
    </span>
  );
}
